var React = require('react');

function CheckBlue (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_4170_3043)","key":0},React.createElement("path",{"d":"M12.8636 3.25362C13.0464 3.42315 13.0464 3.70206 12.8636 3.87159L4.97076 11.3091C4.79085 11.4814 4.49487 11.4814 4.31496 11.3091L0.135978 7.37159C-0.0453259 7.20206 -0.0453259 6.92315 0.135978 6.75362C0.317165 6.58136 0.611116 6.58136 0.792478 6.75362L4.64286 10.3821L12.2078 3.25362C12.3877 3.08245 12.6837 3.08245 12.8636 3.25362Z","fill":"#005AAA"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_4170_3043"},React.createElement("rect",{"width":"13","height":"14","fill":"white","transform":"translate(0 0.5)"})))]);
}

CheckBlue.defaultProps = {"width":"13","height":"15","viewBox":"0 0 13 15","fill":"none"};

module.exports = CheckBlue;

CheckBlue.default = CheckBlue;
